export default __webpack_public_path__ + "static/media/warning--hairpin-curve-left--g2.afaea372.png";